import { Link } from 'react-router-dom';
import { useLanguage } from '../../core/hooks/use-language';
import { useTranslation } from '../../core/hooks/use-translation';

/**
 * The single dark rule under the wizard — the landing page's footer gradient with none of its
 * columns, which is what a page a customer is filling in should carry.
 *
 * The year is interpolated rather than written into the translation, as the landing page's footer
 * already does: the live page hard-codes 2026 in both languages, which goes stale silently twice.
 */
export function BookingFooter() {
    const { t } = useTranslation();
    const language = useLanguage();

    return (
        <footer className="footer">
            <div className="footer-in">
                <span className="fc">
                    {t('site.footer.copy').replace('{year}', String(new Date().getFullYear()))}{' '}
                    <Link to={`/${language}/policy`}>{t('site.footer.policy')}</Link>
                </span>
                <span className="ft">{t('site.footer.tagline')}</span>
            </div>
        </footer>
    );
}
